import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../services/api';

export function useBackups() {
  return useQuery({
    queryKey: ['backups'],
    queryFn: async () => {
      const response = await api.get('/cms/backups');
      return response.data;
    },
    staleTime: 30 * 1000,
  });
}

export function useCreateBackup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const response = await api.post('/cms/backups');
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['backups'] });
    },
  });
}

export function useDeleteBackup() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (id) => {
      const response = await api.delete(`/cms/backups/${id}`);
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['backups'] });
    },
  });
}

export function useBackupDetail(id) {
  return useQuery({
    queryKey: ['backups', id],
    queryFn: async () => {
      const response = await api.get(`/cms/backups/${id}`);
      return response.data;
    },
    enabled: !!id,
  });
}

export function useRestorePreview() {
  return useMutation({
    mutationFn: async ({ id, collections, includeAuth }) => {
      const response = await api.post(`/cms/backups/${id}/restore/preview`, {
        collections,
        includeAuth,
      });
      return response.data;
    },
  });
}

export function useExecuteRestore() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ id, collections, includeAuth, confirmToken }) => {
      const response = await api.post(`/cms/backups/${id}/restore`, {
        collections,
        includeAuth,
        confirmToken,
      });
      return response.data;
    },
    onSuccess: () => {
      // Invalidate everything — restore touches many collections.
      queryClient.invalidateQueries();
    },
  });
}
